import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import React from 'react';
import TextField from '@mui/material/TextField';

const DropDown = ({SelectProps, InputProps, size, ...props}) => {
  const selectProps = {
    IconComponent: ExpandMoreIcon,
    autoWidth: true,
    ...SelectProps,
  };

  return (
    <TextField
      select
      fullWidth
      size={size === 'xsmall' ? 'small' : size}
      SelectProps={selectProps}
      InputProps={{sx: {fontSize: size === 'xsmall' ? 14 : 16}, ...InputProps}}
      {...props}
    />
  );
};

DropDown.propTypes = {
  SelectProps: PropTypes.object,
  InputProps: PropTypes.object,
  margin: PropTypes.string,
  size: PropTypes.string,
};

DropDown.defaultProps = {
  SelectProps: {},
  variant: 'outlined',
  margin: 'normal',
};

export default DropDown;
